import { createSlice } from "@reduxjs/toolkit";
import http from "../../common/cticApi";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";

// initial state
export const initialState = {
  loading: false,
  error: null,
  success: false,
  accessToken: "",
};

// our slice
const changePasswordSlice = createSlice({
  name: "changePassword",
  initialState,
  reducers: {
    setLoading: (state) => {
      state.loading = true;
    },
    setError: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
      state.success = false;
    },
    setSuccess: (state) => {
      state.loading = false;
      state.error = false;
      state.success = true;
    },
    setAccessToken: (state, { payload }) => {
      state.accessToken = payload;
    },
  },
});
// export the actions
export const { setLoading, setError, setSuccess, reset, setAccessToken } =
  changePasswordSlice.actions;

export const changePasswordSelector = (state) => state.changePassword;

// export the default reducer
export default changePasswordSlice.reducer;

// change password
export const changePassword =
  (
    username,
    currentpassword,
    newpassword,
    oktaUserId,
    IsPageLoad,
    location,
    navigate
  ) =>
  async (dispatch) => {
    try {
      const params = new URLSearchParams(location.search);
      const lang = params.get("LANG");
      const data = params.get("data");
      dispatch(setLoading());
      let requestData = window.location.href.includes("CreatePassword")
        ? {
            UserName: username || "",
            Email: username,
            NewPassword: newpassword,
            IsPageLoad,
          }
        : {
            UserName: username,
            CurrentPassword: currentpassword,
            NewPassword: newpassword,
            oktaUserId,
          };

      let { data: response } = await http.post(
        window.location.href.includes("changepassword")
          ? "/User/ChangePassword"
          : `/User/CreatePassword?LANG=${lang}&data=${data}`,
        requestData
      );

      if (response.responseCode == 0) {
        localStorage.setItem("userWelcomeEmail", response.responseObject.email);
        dispatch(setSuccess());
        if (!IsPageLoad) {
          toast.success(
            window.location.href.includes("ChangePassword")
              ? "Password changed successfully!"
              : "Password created successfully!"
          );
          navigate("/");
        }
      } else {
        if (response.responseCode == -2) {
          dispatch(setError("-2"));
        } else {
          dispatch(setError(response.responseDescription));
        }
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.title
          : error.message;
      dispatch(setError(errorMessage));
    }
  };

export async function changeOktaPassword(
  oktaDomain,
  oktaUserId,
  oldPassword,
  newPassword,
  accessToken
) {
  try {
    const user = {
      oldPassword: oldPassword,
      newPassword: newPassword,
    };

    const response = await fetch(
      `https://${oktaDomain}.okta.com/api/v1/users/${oktaUserId}/credentials/change_password`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // Add any additional headers required by Okta, such as Authorization
          Authorization: `SSWS ${accessToken}`,
        },
        body: JSON.stringify(user),
      }
    );

    if (!response.ok) {
      // Optional: log the error response
      const errorData = await response.json();
      console.error("Error changing password:", errorData);
      return false;
    }

    return true;
  } catch (ex) {
    console.error("Exception changing password:", ex);
    return false;
  }
}
